import { QueryClient } from '@tanstack/react-query';

import { logger } from './logger';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60,
      retry: (failureCount, error) => {
        if (error instanceof Error && error.message.includes('401')) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      onError: (error) => {
        logger.error('Mutation error', error);
      },
    },
  },
});
